import { type Ref } from 'react';
import classNames from 'classnames';

import { type SliderConfig, type SliderSlide } from '@jsmdg/yoshi';
import { getSlideSizingVars } from './getSlideSizingVars';
import styles from './LazySlider.module.scss';

type StaticSlideRowProps = {
    readonly slides: SliderSlide[];
    readonly config: SliderConfig;
    readonly wrapperClassName?: string;
    readonly slideClassName?: string;
    readonly onTouchStart?: () => void;
    readonly onTouchMove?: () => void;
    readonly ref?: Ref<HTMLDivElement>;
};

const StaticSlideRow = ({
    config,
    onTouchMove,
    onTouchStart,
    ref,
    slideClassName,
    slides,
    wrapperClassName,
}: StaticSlideRowProps): JSX.Element => (
    <div
        ref={ref}
        className={classNames(styles.row, wrapperClassName)}
        style={getSlideSizingVars(config)}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
    >
        {slides.map(slide => (
            <div key={slide.key} className={classNames(styles.slide, slideClassName)}>
                {slide.content}
            </div>
        ))}
    </div>
);

export { StaticSlideRow };
